// The networks Enflux publishes to, scrolling left → right in an infinite
// marquee. Brand glyphs come from `simple-icons`, rendered monochrome in
// currentColor so they sit in the same muted white as the rest of the strip.
//
// simple-icons dropped LinkedIn (and never carried Google Business Profile),
// so LinkedIn's path is inlined below and GBP borrows the Google mark.
import { siX, siInstagram, siFacebook, siTiktok, siYoutube, siGoogle } from 'simple-icons';

const LINKEDIN_PATH =
	'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z';

interface NetworkMark {
	/** Shown next to the glyph. Not always the icon's own title (GBP). */
	label: string;
	path: string;
}

const NETWORKS: NetworkMark[] = [
	{ label: 'X', path: siX.path },
	{ label: 'Instagram', path: siInstagram.path },
	{ label: 'Facebook', path: siFacebook.path },
	{ label: 'LinkedIn', path: LINKEDIN_PATH },
	{ label: 'TikTok', path: siTiktok.path },
	{ label: 'YouTube', path: siYoutube.path },
	{ label: 'Google Business Profile', path: siGoogle.path },
];

export default function LogoStrip() {
	return (
		<div className="lp-marquee" aria-label="Supported networks">
			<div className="lp-marquee-track">
				{[0, 1].map((half) => (
					<div key={half} className="flex items-center" aria-hidden={half === 1}>
						{NETWORKS.map((network, i) => (
							<div
								key={`${half}-${i}`}
								className="lp-marquee-item gap-2 text-white/[0.45] transition-colors hover:text-white/70"
							>
								<svg viewBox="0 0 24 24" className="h-[18px] w-[18px] flex-none" aria-hidden>
									<path d={network.path} fill="currentColor" />
								</svg>
								<span className="whitespace-nowrap text-[13px] font-medium">{network.label}</span>
							</div>
						))}
					</div>
				))}
			</div>
		</div>
	);
}
